import angular from 'angular';
import _ from "lodash";

(function () {
    'use strict';
    angular.module('app.core').factory('BillingAddressDA', BillingAddressDA);

    BillingAddressDA.$inject = ['CONF', 'Restangular','BillingAddress'];

    /* @ngInject */
    function BillingAddressDA(CONF, Restangular,BillingAddress) {
        var baseUrl = CONF.apiBaseUrl + '/v1/billing-address';

        var exports = {
            getAllBillingAddress: getAllBillingAddress,
            saveBillingAddress: saveBillingAddress,
            getBillingAddress:getBillingAddress,
            updateBillingAddress:updateBillingAddress
        };

        return exports;


        function getAllBillingAddress(page = 0, size = 5, legalEntityId) {
            return Restangular.all(baseUrl)
                .one('search')
                .customGET('', {
                        page: page,
                        size: size,
                        legalEntityId: legalEntityId
                    }
                )

        .then(function (billingAddresses) {
            return {
                totalElements: billingAddresses.totalElements,
                billingAddresses: _.map(billingAddresses.content, function (se) {
                         return new BillingAddress(se);
                    })
                };
            });
        }

        function saveBillingAddress(billingAddressDto, legalEntityId) {
            return Restangular.all(baseUrl + '/' + legalEntityId).post(billingAddressDto);
        }
        function updateBillingAddress(billingAddressDto, legalEntityId) {
            return Restangular.all(baseUrl + '/' + legalEntityId).customPUT(billingAddressDto);
        }
        function getBillingAddress(billingAddressId) {
            return Restangular.one(baseUrl + '/' + billingAddressId).get().then(data=> {
                    return new BillingAddress(data)

            });
        }
    }
})();
